
  export const findText = ({ texts, textId }) => {
    return texts?.find((text) => text.id === textId) || null;
  };
  